<template>
  <div>
    <div class="p-2">
      <h6 class="font120 bold border-bottom">
        This Week
      </h6>
      <div v-for="notification in week" :key="notification.id">
        <single-notification :notification="notification" @removed="removeNotification"></single-notification>
      </div>

      <h6 class="font120 bold border-bottom">
        This Month
      </h6>
      <div v-for="notification in month" :key="notification.id">
        <single-notification :notification="notification" @removed="removeNotification"></single-notification>
      </div>

      <template v-if="all">
        <h6 class="font120 bold border-bottom">
          Older
        </h6>
        <div v-for="notification in older" :key="notification.id">
          <single-notification :notification="notification" @removed="removeNotification"></single-notification>
        </div>
      </template>
    </div>

    <router-link v-if="!all" to="/notifications" class="btn btn-orange btn-block text-white">READ MORE&nbsp;&nbsp;<font-awesome-icon icon="angle-double-right"></font-awesome-icon></router-link>
  </div>
</template>

<script>
import SingleNotification from '../SingleNotification';

export default {
  name: 'NotificationsWidget',
  components: {SingleNotification},
  data () {
    return {
      notifications: {
        loaded: false,
        limit: 5,
        all: []
      },
      pastWeek: this.$moment().subtract(1, 'week'),
      pastMonth: this.$moment().subtract(1, 'month'),
    };
  },
  methods: {
    loadNotifications () {
      this.axios.get('/notifications', {params: {notifiable_id: this.$auth.user().id}}).then(rsp => {
        this.notifications.all = rsp.data.data;
        this.notifications.loaded = false;
        this.$store.commit('setNotificationsCount', this.unread);
      }).catch(err => this.$snotify.error(err.response.data.message, 'Notifications Error'));
    },
    removeNotification (notification) {
      let index = this.notifications.all.findIndex(item => item.id === notification.id);
      this.notifications.all.splice(index, 1);
      this.$store.commit('setNotificationsCount', this.unread);
    }
  },
  computed: {
    week () {
      return this.notifications.all.filter(notif => notif.read_at === null).filter(notif => {
        return this.$moment(notif.created_at).isAfter(this.pastWeek);
      });
    },
    month () {
      return this.notifications.all.filter(notif => notif.read_at === null).filter(notif => {
        return this.$moment(notif.created_at).isAfter(this.pastMonth) && this.$moment(notif.created_at).isBefore(this.pastWeek);
      });
    },
    older () {
      return this.notifications.all.filter(notif => notif.read_at === null).filter(notif => {
        return this.$moment(notif.created_at).isBefore(this.pastMonth);
      });
    },
    unread () {
      return this.notifications.all.filter(notif => notif.read_at === null).length;
    }
  },
  mounted () {
    this.loadNotifications();
  },
  props: {
    all: {
      type: Boolean,
      default: false
    }
  }
};
</script>
